import { Outlet } from "react-router-dom";
import { Footer } from "./Footer";
import { Navbar } from "./Navbar";
import { StoreClosedBanner } from "./StoreClosedBanner";

export function StorefrontLayout() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="storefront-layout">
      <StoreClosedBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
